import { gql } from "@apollo/client";

const MAILCHIMP_INVITE_ADDITIONAL_USER = gql`
  mutation InviteAdditionalUser(
    $userId: ID!
    $donorDafName: String
    $donorFirstName: String
    $donorLastName: String
    $productId: ID!
    $recipientEmail: String
    $recipientFirstName: String
    $recipientLastName: String
    $branding: String
  ) {
    inviteAdditionalUser(
      userId: $userId
      donorDafName: $donorDafName
      donorFirstName: $donorFirstName
      donorLastName: $donorLastName
      productId: $productId
      recipientEmail: $recipientEmail
      recipientFirstName: $recipientFirstName
      recipientLastName: $recipientLastName
      branding: $branding
    ) {
      mailChimpResponse {
        _id
        email
        queued_reason
        reject_reason
        status
      }
      userProduct {
        associationType
        expectedEmail
        expectedFirstName
        expectedLastName
        inviteConfirmationToken
        inviteExpirationDate
        inviteStatus
        relationship
        successorPriority
        meta {
          testData
        }
      }
    }
  }
`;

const MAILCHIMP_USER_VERIFICATION = gql`
  mutation NewUserVerificationEmail(
    $donorEmail: String
    $donorFirstName: String
    $donorId: String
    $branding: String
  ) {
    newUserVerificationEmail(
      donorEmail: $donorEmail
      donorFirstName: $donorFirstName
      donorId: $donorId
      branding: $branding
    ) {
      _id
      email
      queued_reason
      reject_reason
      status
    }
  }
`;

//DonorLinkingAdvisorEmail
const MAILCHIMP_DONOR_LINKING_ADVISOR = gql`
  mutation DonorRequestAdvisorLink(
    $advisorEmail: String!
    $advisorFirstName: String!
    $donorId: ID!
    $advisorLastName: String!
    $donorFirstName: String!
    $donorLastName: String!
  ) {
    donorRequestAdvisorLink(
      advisorEmail: $advisorEmail
      advisorFirstName: $advisorFirstName
      donorId: $donorId
      advisorLastName: $advisorLastName
      donorFirstName: $donorFirstName
      donorLastName: $donorLastName
    ) {
      mailChimpResponse {
        _id
        email
        queued_reason
        reject_reason
        status
      }
      userInvite {
        createdAt
        expectedEmail
        expectedFirstName
        expectedLastName
        inviteConfirmationToken
        inviteExpirationDate
        inviteStatus
        inviteType

        linkedField
        roles
        senderId
        type
        updatedAt
      }
    }
  }
`;

const MAILCHIMP_ADVISOR_LINKING_DONOR = gql`
  mutation AdvisorRequestDonorLink(
    $advisorId: ID!
    $advisorFirstName: String!
    $advisorLastName: String!
    $advisorFirmName: String!
    $donorEmail: String!
    $donorFirstName: String!
    $donorLastName: String!
    $branding: String
    $sso: String
  ) {
    advisorRequestDonorLink(
      advisorId: $advisorId
      advisorFirstName: $advisorFirstName
      advisorLastName: $advisorLastName
      advisorFirmName: $advisorFirmName
      donorEmail: $donorEmail
      donorFirstName: $donorFirstName
      donorLastName: $donorLastName
      branding: $branding
      sso: $sso
    ) {
      mailChimpResponse {
        _id
        email
        queued_reason
        reject_reason
        status
      }
      userInvite {
        createdAt
        expectedEmail
        expectedFirstName
        expectedLastName
        inviteConfirmationToken
        inviteExpirationDate
        inviteStatus
        inviteType
        linkedDocumentId {
          entityName
        }
        linkedField
        roles
        senderId
        type
        updatedAt
      }
    }
  }
`;

const MAILCHIMP_FIRM_USER_LINKING_ADVISOR = gql`
  mutation FirmUserRequestAdvisorLink(
    $advisorEmail: String
    $advisorFirstName: String
    $advisorLastName: String
    $firmUserId: ID
    $firmId: ID
    $roles: [String]
    $branding: String
    $sso: String
  ) {
    firmUserRequestAdvisorLink(
      advisorEmail: $advisorEmail
      advisorFirstName: $advisorFirstName
      advisorLastName: $advisorLastName
      firmUserId: $firmUserId
      firmId: $firmId
      roles: $roles
      branding: $branding
      sso: $sso
    ) {
      mailChimpResponse {
        _id
        email
        queued_reason
        reject_reason
        status
      }
      userInvite {
        createdAt
        expectedEmail
        expectedFirstName
        expectedLastName
        inviteConfirmationToken
        inviteExpirationDate
        inviteStatus
        inviteType
        linkedDocumentId {
          entityName
        }
        linkedField
        roles
        senderId
        type
        updatedAt
      }
    }
  }
`;

const MAILCHIMP_FIRM_USER_LINKING_FIRM_USER = gql`
  mutation FirmUserRequestFirmUserLink(
    $firmUserId: ID
    $firmId: ID
    $roles: [String]
    $newAdminEmail: String
    $newAdminFirstName: String
    $newAdminLastName: String
    $branding: String
    $sso: String
  ) {
    firmUserRequestFirmUserLink(
      firmUserId: $firmUserId
      firmId: $firmId
      roles: $roles
      newAdminEmail: $newAdminEmail
      newAdminFirstName: $newAdminFirstName
      newAdminLastName: $newAdminLastName
      branding: $branding
      sso: $sso
    ) {
      mailChimpResponse {
        _id
        email
        queued_reason
        reject_reason
        status
      }
      userInvite {
        createdAt
        expectedEmail
        expectedFirstName
        expectedLastName
        inviteConfirmationToken
        inviteExpirationDate
        inviteStatus
        inviteType
        linkedDocumentId {
          entityName
        }
        linkedField
        roles
        senderId
        type
        updatedAt
      }
    }
  }
`;

const MAILCHIP_PARTNER_USER_LINKING_PARTNER_USER = gql`
  mutation PartnerUserRequestPartnerUserLink(
    $userId: ID
    $partnerId: ID
    $roles: [String]
    $newPartnerEmail: String
    $newPartnerFirstName: String
    $newPartnerLastName: String
    $branding: String
    $sso: String
  ) {
    partnerUserRequestPartnerUserLink(
      userId: $userId
      partnerId: $partnerId
      roles: $roles
      newPartnerEmail: $newPartnerEmail
      newPartnerFirstName: $newPartnerFirstName
      newPartnerLastName: $newPartnerLastName
      branding: $branding
      sso: $sso
    ) {
      mailChimpResponse {
        _id
        email
        queued_reason
        reject_reason
        status
      }
      userInvite {
        createdAt
        expectedEmail
        expectedFirstName
        expectedLastName
        inviteConfirmationToken
        inviteExpirationDate
        inviteStatus
        inviteType
        linkedDocumentId {
          entityName
        }
        linkedField
        roles
        senderId
        type
        updatedAt
      }
    }
  }
`;

const MAILCHIMP_WELCOME_DONOR = gql`
  mutation WelcomeDonorEmail($donorEmail: String, $donorFirstName: String, $donorSource: String, $branding: String) {
    welcomeDonorEmail(donorEmail: $donorEmail, donorFirstName: $donorFirstName, donorSource: $donorSource, branding: $branding) {
      _id
      email
      queued_reason
      reject_reason
      status
    }
  }
`;

const MAILCHIMP_OTHER_DONATION = gql`
  mutation OtherDonationEmail(
    $asset: String
    $donorEmail: String
    $donorFirstName: String
    $donorLastName: String
    $donorMessage: String
    $forFund: String
  ) {
    otherDonationEmail(
      asset: $asset
      donorEmail: $donorEmail
      donorFirstName: $donorFirstName
      donorLastName: $donorLastName
      donorMessage: $donorMessage
      forFund: $forFund
    ) {
      _id
      email
      queued_reason
      reject_reason
      status
    }
  }
`;

const CRYPTO_CONTRIBUTION_EMAIL = gql`
  mutation CryptoContributionEmail($transactionId: ID, $sendContributionReceipt: Boolean) {
    cryptoContributionEmail(
      transactionId: $transactionId
      sendContributionReceipt: $sendContributionReceipt
    ) {
      _id
      email
      queued_reason
      reject_reason
      status
    }
  }
`;

// Old enpoints that have not yet been updated to the new schema

const CART_SUBMIT_EMAILS = gql`
  mutation CartSubmitEmails(
    $donorEmail: String
    $donorFirstName: String
    $donorId: ID
    $donorLastName: String
    $floatingGrant: Boolean
    $transactionIds: [CartSubmitIds]
  ) {
    cartSubmitEmails(
      donorEmail: $donorEmail
      donorFirstName: $donorFirstName
      donorId: $donorId
      donorLastName: $donorLastName
      floatingGrant: $floatingGrant
      transactionIds: $transactionIds
    ) {
      _id
      email
      queued_reason
      reject_reason
      status
    }
  }
`;

const REC_ORG_EMAILS = gql`
  mutation RecOrgEmails(
    $requestedBy: String
    $accountNumber: String
    $address1: String
    $address2: String
    $city: String
    $country: String
    $donorEmail: String
    $donorFirstName: String
    $donorId: ID
    $donorLastName: String
    $ein: String
    $organizationContact: String
    $organizationDescription: String
    $organizationName: String
    $phoneNumber: String
    $reason: String
    $routingNumber: String
    $state: String
    $website: String
    $zip: String
  ) {
    recOrgEmails(
      requestedBy: $requestedBy
      accountNumber: $accountNumber
      address1: $address1
      address2: $address2
      city: $city
      country: $country
      donorEmail: $donorEmail
      donorFirstName: $donorFirstName
      donorId: $donorId
      donorLastName: $donorLastName
      ein: $ein
      organizationContact: $organizationContact
      organizationDescription: $organizationDescription
      organizationName: $organizationName
      phoneNumber: $phoneNumber
      reason: $reason
      routingNumber: $routingNumber
      state: $state
      website: $website
      zip: $zip
    ) {
      _id
      email
      queued_reason
      reject_reason
      status
    }
  }
`;

const MAILCHIMP_REQUEST_PASSWORD_RESET = gql`
  mutation RequestPasswordReset($userEmail: String, $branding: String) {
    requestPasswordReset(userEmail: $userEmail, branding: $branding) {
      _id
      email
      queued_reason
      reject_reason
      status
    }
  }
`;

const LIQUIDATION_TRANSFER_REQUEST_EMAIL = gql`
  mutation LiquidationRequestEmail(
    $productId: ID
    $requestedTransferAmount: Decimal128
    $transactionIds: [ID]
    $typename: String
  ) {
    liquidationRequestEmail(
      productId: $productId
      requestedTransferAmount: $requestedTransferAmount
      transactionIds: $transactionIds
      typename: $typename
    ) {
      _id
      email
      queued_reason
      reject_reason
      status
    }
  }
`;

const DECLINE_GRANT_EMAIL = gql`
  mutation DeclineGrantEmail($transactionId: ID, $cancellationReason: String) {
    declineGrantEmail(transactionId: $transactionId, cancellationReason: $cancellationReason) {
      _id
      email
      status
    }
  }
`;

const DOCUMENT_REMINDER_EMAIL = gql`
  mutation DocumentReminderEmail(
    $recipient: String
    $document: String
    $recipientFirstName: String
    $recipientEmail: String
    $donorFirstName: String
    $donorLastName: String
    $dafName: String
    $assetName: String
    $equityContributionDonationDate: Date
    $assetId: ID
    $transactionId: ID
  ) {
    documentReminderEmail(
      recipient: $recipient
      document: $document
      recipientFirstName: $recipientFirstName
      recipientEmail: $recipientEmail
      donorFirstName: $donorFirstName
      donorLastName: $donorLastName
      dafName: $dafName
      assetName: $assetName
      equityContributionDonationDate: $equityContributionDonationDate
      assetId: $assetId
      transactionId: $transactionId
    ) {
      _id
      email
      queued_reason
      reject_reason
      status
    }
  }
`;

const ASSET_AGREEMENT_INVITE_EMAIL = gql`
  mutation AssetAgreementInvite($donorId: String, $fileCategory: String) {
    assetAgreementInvite(donorId: $donorId, fileCategory: $fileCategory) {
      _id
      email
      queued_reason
      reject_reason
      status
    }
  }
`;

export {
  MAILCHIMP_DONOR_LINKING_ADVISOR,
  MAILCHIMP_ADVISOR_LINKING_DONOR,
  MAILCHIMP_FIRM_USER_LINKING_ADVISOR,
  MAILCHIMP_FIRM_USER_LINKING_FIRM_USER,
  MAILCHIP_PARTNER_USER_LINKING_PARTNER_USER,
  MAILCHIMP_USER_VERIFICATION,
  MAILCHIMP_WELCOME_DONOR,
  MAILCHIMP_OTHER_DONATION,
  MAILCHIMP_INVITE_ADDITIONAL_USER,
  MAILCHIMP_REQUEST_PASSWORD_RESET,
  CART_SUBMIT_EMAILS,
  REC_ORG_EMAILS,
  LIQUIDATION_TRANSFER_REQUEST_EMAIL,
  DECLINE_GRANT_EMAIL,
  DOCUMENT_REMINDER_EMAIL,
  ASSET_AGREEMENT_INVITE_EMAIL,
  CRYPTO_CONTRIBUTION_EMAIL,
};
